const d =
	'M480-55q-29 0-54-12.5T393-105h-14q-31-5-51.5-29.238Q307-158.475 307-189v-130q-67-47.355-104.5-116.798Q165-505.24 165-590q0-130.662 92-223.331Q349-906 479.762-906q130.761 0 223.5 92.669Q796-720.662 796-590q0 85-38 154.5T654-319v130q0 30.525-21 54.762Q612-110 582-105h-14q-9 25-34.5 37.5T480-55Zm-79-134h158v-44H401v44Zm0-84h158v-40H401v40Zm108-109v-126l94-94-39-39-84 84-84-84-39 39 94 94v126h58Z';

export default d;
